<template>
    <DCard
        padding
    >
        <DTable
            :items="fulfillmentModules"
            :fields="[
                {key: 'brand_name', label: __('products.fulfillment_modules.index.table.headers.module_name')},
                {key: 'actions', label: __('products.fulfillment_modules.index.table.headers.available'),_style: { minWidth: '5%' }}
            ]"
            hover
        >
            <template #brand_name="{item}">
                <td>
                    {{ item.name }} <br>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DSwitch
                            v-model="item.active"
                            color="success"
                            variant="3d"
                            @update:checked="toggleAvailableModules(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
    </DCard>
</template>

<script>

export default {
    name: 'FulfillmentModules',
    props: {
        fulfillmentModules: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        toggleAvailableModules (module) {
            this.$inertia.post(this.$route('products.fulfillment-modules.toggle_module_available', {
                module_name: module.name,
                active: !module.active
            }))
        }
    }
}
</script>
